import React from 'react';
import { Card, CardContent } from './ui/card';
import { fitCheckData } from '../data/mockData';
import { CheckCircle2, XCircle } from 'lucide-react';

const FitCheck = () => {
  return (
    <section id="fit-check" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            {fitCheckData.sectionTitle}
          </h2>
        </div>

        {/* Two Column Layout */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* This is For You */}
          <Card className="border-2 border-blue-200 bg-blue-50/50 shadow-lg overflow-hidden">
            <div className="bg-blue-600 p-6">
              <h3 className="text-2xl font-bold text-white flex items-center gap-3">
                <CheckCircle2 className="h-8 w-8" />
                This is For You If
              </h3>
            </div>
            <CardContent className="p-8">
              <ul className="space-y-4">
                {fitCheckData.forYou.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="flex-shrink-0 mt-1">
                      <div className="w-6 h-6 rounded-full bg-blue-600 flex items-center justify-center">
                        <CheckCircle2 className="h-4 w-4 text-white" />
                      </div>
                    </div>
                    <p className="text-slate-700 leading-relaxed">{item}</p>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>

          {/* This is NOT For You */}
          <Card className="border-2 border-slate-200 bg-slate-50 shadow-lg overflow-hidden">
            <div className="bg-slate-700 p-6">
              <h3 className="text-2xl font-bold text-white flex items-center gap-3">
                <XCircle className="h-8 w-8" />
                This is NOT For You If
              </h3>
            </div>
            <CardContent className="p-8">
              <ul className="space-y-4">
                {fitCheckData.notForYou.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="flex-shrink-0 mt-1">
                      <div className="w-6 h-6 rounded-full bg-slate-400 flex items-center justify-center">
                        <XCircle className="h-4 w-4 text-white" />
                      </div>
                    </div>
                    <p className="text-slate-700 leading-relaxed">{item}</p>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default FitCheck;
